import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
    FullscreenFrame,
    FullscreenOverlay,
    FullscreenMain,
    FullscreenHeader,
} from '@99designs/common/components/Fullscreen';
import IconButton from 'launch/components/IconButton';

class Modal extends Component {
    constructor(props) {
        super(props);

        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        const { onDismiss, isVisible, children } = this.props;

        if (isVisible) {
            return (
                <FullscreenOverlay
                    isClosing={!isVisible}
                    isActive={isVisible}
                    hasOpeningAndClosingAnimation={true}
                    isScrollableSmallScreens={true}
                    enableScroll={false}
                >
                    <FullscreenFrame.Frame isSidebarHidden={true}>
                        <FullscreenFrame.Main>
                            <FullscreenMain.Main hasHeader={true}>
                                <FullscreenMain.Header>
                                    <FullscreenHeader.Header>
                                        {onDismiss && (
                                            <FullscreenHeader.Item variations={['last']}>
                                                <IconButton
                                                    icon="x-3"
                                                    variations={['circled']}
                                                    onClick={onDismiss}
                                                />
                                            </FullscreenHeader.Item>
                                        )}
                                    </FullscreenHeader.Header>
                                </FullscreenMain.Header>

                                <FullscreenMain.Body>
                                    <div className="fullscreen-content">{children}</div>
                                </FullscreenMain.Body>
                            </FullscreenMain.Main>
                        </FullscreenFrame.Main>
                    </FullscreenFrame.Frame>
                </FullscreenOverlay>
            );
        }

        return null;
    }

    handleKeyDown(e) {
        const { onDismiss } = this.props;

        if (!onDismiss) {
            return;
        }

        // ESC
        if (e.keyCode === 27) {
            onDismiss();
        }
    }
}

Modal.defaultProps = {
    isVisible: true,
    onDismiss: null,
};

Modal.propTypes = {
    onDismiss: PropTypes.func,
    isVisible: PropTypes.bool,
};

export default Modal;



// WEBPACK FOOTER //
// ./js/common/components/Modal.jsx